import { render, staticRenderFns } from "./AfWithdraw.vue?vue&type=template&id=284938e6&scoped=true"
import script from "./AfWithdraw.vue?vue&type=script&lang=js"
export * from "./AfWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "284938e6",
  null
  
)

export default component.exports